import PasscodeInternal, { componentName } from './PasscodeInternal';

customElements.define(componentName, PasscodeInternal);
